import {
  TaskDocument,
  TaskQuery,
  TaskQueryVariables,
  TaskRefFragment,
  TaskRefFragmentDoc,
  withStandardRefSuspenseHook,
} from '@spotify/confidence-graphql';

export const useTaskRefSuspense = withStandardRefSuspenseHook<
  TaskQuery,
  TaskRefFragment,
  'task',
  TaskQueryVariables
>(TaskDocument, 'task', TaskRefFragmentDoc, 'TaskRef', 'ObservationsV1Task');
